import React from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedComponent } from '../../../redux/editorSlice';
import { SkinSelector } from '../CommonProperties';
import { usePropertyPanel } from '../PropertyPanelContext';

const PaymentProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const { handleComponentPropsChange } = usePropertyPanel();
  
  if (!selectedComponent) {
    return <div>컴포넌트를 선택해주세요.</div>;
  }
  
  console.log('[PaymentProperties] selectedComponent:', selectedComponent);
  console.log('[PaymentProperties] selectedComponent.type:', selectedComponent.type);
  
  return (
    <>
      {/* 스킨 선택 */}
      <SkinSelector
        selectedComponent={selectedComponent}
        onSkinChange={(skin) => handleComponentPropsChange('skin', skin)}
      />

      {/* 결제 기본 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H3V10h18v8z" fill="currentColor"/>
          </svg>
          결제 설정
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>제목</label>
          <input 
            type="text"
            value={selectedComponent.componentProps?.title || '결제하기'}
            onChange={(e) => handleComponentPropsChange('title', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>빈 장바구니 메시지</label>
          <input 
            type="text"
            value={selectedComponent.componentProps?.emptyText || '장바구니가 비어 있습니다.'}
            onChange={(e) => handleComponentPropsChange('emptyText', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>배송비</label>
          <input 
            type="number"
            min="0"
            value={selectedComponent.componentProps?.shippingFee || 4000}
            onChange={(e) => handleComponentPropsChange('shippingFee', parseInt(e.target.value) || 0)}
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>무료배송 기준금액</label>
          <input 
            type="number"
            min="0"
            value={selectedComponent.componentProps?.freeShippingThreshold || 50000}
            onChange={(e) => handleComponentPropsChange('freeShippingThreshold', parseInt(e.target.value) || 0)}
            style={{ width: '100%' }}
          />
        </div>
      </div>

      {/*/!* 표시 옵션 *!/*/}
      {/*<div className="property-group">*/}
      {/*  <div className="property-group-title">*/}
      {/*    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
      {/*      <path d="M12 2L2 7v10l10 5 10-5V7L12 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
      {/*    </svg>*/}
      {/*    표시 옵션*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label style={{ minWidth: '30%' }}>주문 요약</label>*/}
      {/*    <div className="custom-toggle-switch">*/}
      {/*      <input */}
      {/*        id="toggle-order-summary"*/}
      {/*        type="checkbox" */}
      {/*        checked={selectedComponent.componentProps?.showOrderSummary !== false}*/}
      {/*        onChange={(e) => handleComponentPropsChange('showOrderSummary', e.target.checked)}*/}
      {/*      />*/}
      {/*      <label htmlFor="toggle-order-summary" className="toggle-switch-label">*/}
      {/*        <span className="toggle-track"></span>*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label style={{ minWidth: '30%' }}>배송 정보</label>*/}
      {/*    <div className="custom-toggle-switch">*/}
      {/*      <input */}
      {/*        id="toggle-shipping-info"*/}
      {/*        type="checkbox" */}
      {/*        checked={selectedComponent.componentProps?.showShippingInfo !== false}*/}
      {/*        onChange={(e) => handleComponentPropsChange('showShippingInfo', e.target.checked)}*/}
      {/*      />*/}
      {/*      <label htmlFor="toggle-shipping-info" className="toggle-switch-label">*/}
      {/*        <span className="toggle-track"></span>*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label style={{ minWidth: '30%' }}>결제 수단</label>*/}
      {/*    <div className="custom-toggle-switch">*/}
      {/*      <input */}
      {/*        id="toggle-payment-methods"*/}
      {/*        type="checkbox" */}
      {/*        checked={selectedComponent.componentProps?.showPaymentMethods !== false}*/}
      {/*        onChange={(e) => handleComponentPropsChange('showPaymentMethods', e.target.checked)}*/}
      {/*      />*/}
      {/*      <label htmlFor="toggle-payment-methods" className="toggle-switch-label">*/}
      {/*        <span className="toggle-track"></span>*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label style={{ minWidth: '30%' }}>쿠폰 입력</label>*/}
      {/*    <div className="custom-toggle-switch">*/}
      {/*      <input */}
      {/*        id="toggle-coupon"*/}
      {/*        type="checkbox" */}
      {/*        checked={selectedComponent.componentProps?.showCouponInput !== false}*/}
      {/*        onChange={(e) => handleComponentPropsChange('showCouponInput', e.target.checked)}*/}
      {/*      />*/}
      {/*      <label htmlFor="toggle-coupon" className="toggle-switch-label">*/}
      {/*        <span className="toggle-track"></span>*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label style={{ minWidth: '30%' }}>포인트 사용</label>*/}
      {/*    <div className="custom-toggle-switch">*/}
      {/*      <input */}
      {/*        id="toggle-points"*/}
      {/*        type="checkbox" */}
      {/*        checked={selectedComponent.componentProps?.showPointUsage !== false}*/}
      {/*        onChange={(e) => handleComponentPropsChange('showPointUsage', e.target.checked)}*/}
      {/*      />*/}
      {/*      <label htmlFor="toggle-points" className="toggle-switch-label">*/}
      {/*        <span className="toggle-track"></span>*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label style={{ minWidth: '30%' }}>약관 동의</label>*/}
      {/*    <div className="custom-toggle-switch">*/}
      {/*      <input */}
      {/*        id="toggle-terms"*/}
      {/*        type="checkbox" */}
      {/*        checked={selectedComponent.componentProps?.showTermsAgreement !== false}*/}
      {/*        onChange={(e) => handleComponentPropsChange('showTermsAgreement', e.target.checked)}*/}
      {/*      />*/}
      {/*      <label htmlFor="toggle-terms" className="toggle-switch-label">*/}
      {/*        <span className="toggle-track"></span>*/}
      {/*      </label>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/*/!* 색상 설정 *!/*/}
      {/*<div className="property-group">*/}
      {/*  <div className="property-group-title">*/}
      {/*    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
      {/*      <path d="M12 2L2 7v10l10 5 10-5V7L12 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>*/}
      {/*    </svg>*/}
      {/*    색상 설정*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label>주요 버튼 색상</label>*/}
      {/*    <input */}
      {/*      type="color" */}
      {/*      value={selectedComponent.componentProps?.primaryButtonColor || '#007bff'}*/}
      {/*      onChange={(e) => handleComponentPropsChange('primaryButtonColor', e.target.value)}*/}
      {/*      style={{ width: '100%', height: '32px' }}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label>보조 버튼 색상</label>*/}
      {/*    <input */}
      {/*      type="color" */}
      {/*      value={selectedComponent.componentProps?.secondaryButtonColor || '#6c757d'}*/}
      {/*      onChange={(e) => handleComponentPropsChange('secondaryButtonColor', e.target.value)}*/}
      {/*      style={{ width: '100%', height: '32px' }}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label>성공 색상</label>*/}
      {/*    <input */}
      {/*      type="color" */}
      {/*      value={selectedComponent.componentProps?.successColor || '#28a745'}*/}
      {/*      onChange={(e) => handleComponentPropsChange('successColor', e.target.value)}*/}
      {/*      style={{ width: '100%', height: '32px' }}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label>오류 색상</label>*/}
      {/*    <input */}
      {/*      type="color" */}
      {/*      value={selectedComponent.componentProps?.errorColor || '#dc3545'}*/}
      {/*      onChange={(e) => handleComponentPropsChange('errorColor', e.target.value)}*/}
      {/*      style={{ width: '100%', height: '32px' }}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label>테두리 색상</label>*/}
      {/*    <input */}
      {/*      type="color" */}
      {/*      value={selectedComponent.componentProps?.borderColor || '#dee2e6'}*/}
      {/*      onChange={(e) => handleComponentPropsChange('borderColor', e.target.value)}*/}
      {/*      style={{ width: '100%', height: '32px' }}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div className="property-row">*/}
      {/*    <label>배경 색상</label>*/}
      {/*    <input */}
      {/*      type="color" */}
      {/*      value={selectedComponent.componentProps?.backgroundColor || '#f8f9fa'}*/}
      {/*      onChange={(e) => handleComponentPropsChange('backgroundColor', e.target.value)}*/}
      {/*      style={{ width: '100%', height: '32px' }}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/*/!* 결제 수단 설정 *!/*/}
      {/*{selectedComponent.componentProps?.showPaymentMethods !== false && (*/}
      {/*  <div className="property-group">*/}
      {/*    <div className="property-group-title">*/}
      {/*      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
      {/*        <path d="M20 12H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>*/}
      {/*        <path d="M20 6H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>*/}
      {/*        <path d="M20 18H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>*/}
      {/*      </svg>*/}
      {/*      결제 수단 관리*/}
      {/*    </div>*/}
      {/*    */}
      {/*    <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>*/}
      {/*      결제 수단은 코드에서 직접 수정하세요.*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*)}*/}
    </>
  );
};

export default PaymentProperties;